import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
const SMSNavbar = () => {
  return (
    <>
      <Navbar bg="dark" expand="lg" variant="dark">
        <Container>
          <Navbar.Brand href="/">
            <img
              src="https://static.wixstatic.com/media/5876d7_e3f236fa7d3c41f092b2909be7962a2a~mv2.png"
              width="120px"
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav>
              <a href="/internal/home" style={{ margin: "10px" }}>
                SMS Records
              </a>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <style>
        {`
            .me-auhref a {
                color: white;
                text-decoration: none;
                }
                .me-auhref a:hover {
                    color: grey;
                    }`}
      </style>
    </>
  );
};

export default SMSNavbar;
